import { useEffect, useState } from 'react';
import axios from 'axios';
import { reviews as fallbackReviews } from '../data/mockData';

const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';
let _cache = null;
let _inflight = null;

export async function fetchReviews() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API_BASE}/api/reviews`)
    .then((r) => {
      const arr = Array.isArray(r.data) ? r.data : [];
      // Адаптация под форму mockData: { id, name, role, text, rating }
      _cache = arr.length
        ? arr.map((it) => ({ id: it.id, name: it.author, role: it.role, text: it.text, rating: it.rating }))
        : fallbackReviews;
      return _cache;
    })
    .catch(() => { _cache = fallbackReviews; return _cache; })
    .finally(() => { _inflight = null; });
  return _inflight;
}

export default function useReviews() {
  const [items, setItems] = useState(() => _cache || fallbackReviews);
  const [loading, setLoading] = useState(() => !_cache);
  useEffect(() => {
    let mounted = true;
    if (!_cache) {
      fetchReviews().then((data) => { if (mounted) { setItems(data); setLoading(false); } });
    } else setLoading(false);
    return () => { mounted = false; };
  }, []);
  return { items, loading };
}
